import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { AccountingCategory, useRepositorySuspenseQuery } from '@mews-commander/data-access';

interface SelectedData {
    chargedAccountingCategoryName: string | null;
    rebatedAccountingCategoryName: string | null;
    canceledItemAccountingCategoryName: string | null;
}

interface Params {
    accountingCategoryId?: string | null;
    rebateAccountingCategoryId?: string | null;
    canceledItemAccountingCategoryId?: string | null;
}

export const useAccountingCategoryNames = ({
    accountingCategoryId,
    canceledItemAccountingCategoryId,
    rebateAccountingCategoryId,
}: Params) => {
    const enterpriseId = useCurrentEnterpriseId();
    const { data } = useRepositorySuspenseQuery(
        'accountingCategories',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ accountingCategories }) =>
                accountingCategories
                    ? pipe(
                          accountingCategories,
                          array.reduce<AccountingCategory, SelectedData>(
                              {
                                  chargedAccountingCategoryName: null,
                                  rebatedAccountingCategoryName: null,
                                  canceledItemAccountingCategoryName: null,
                              },
                              (acc, category) => {
                                  if (category.id === accountingCategoryId) {
                                      acc.chargedAccountingCategoryName = category.name;
                                  }
                                  if (category.id === rebateAccountingCategoryId) {
                                      acc.rebatedAccountingCategoryName = category.name;
                                  }
                                  if (category.id === canceledItemAccountingCategoryId) {
                                      acc.canceledItemAccountingCategoryName = category.name;
                                  }
                                  return acc;
                              }
                          )
                      )
                    : null,
        }
    );
    return data;
};
